import React from "react"; // Force re-compile
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SoftyeKanbanLanding from "./Landingpage";

import Login from "./Login";
import Signup from "./Signup";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SoftyeKanbanLanding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </Router>
  );
}

export default App;
